import * as qs from 'qs';
import * as url from 'url';
import { loadNewsletterPageData, updateNewsletterPopUpData } from '../actions/newsletterAction';
import {
    newsletterPage as newsletterLandingPage,
    requestFormPage,
    thankYouPage,
    welcomePage,
    searchResultPage,
} from '../consts/pageTypes';
import { hasConsentUpdated } from './dataLayer';
import { isNewsletterModalCookie, readCookie, writeSessionCookie } from './cookie';
import { eventTracker } from './EventTracker/EventTracker';
import { getRouteSlugs } from './routing';

/**
 * Checks specific queryparams to create newsletter cookie
 */
export const checkNewsletterQuerystringParams = (
    url_string: string,
    ssr: boolean,
    reposnse?: any,
) => {
    const url = new URL(url_string);
    const utm_source = url.searchParams.get('utm_source');
    const utm_medium = url.searchParams.get('utm_medium');
    if (utm_source && utm_medium) {
        if (utm_source.includes('newsletter_') || utm_medium === 'email') {
            if (!readCookie('isSignedUpForNewsletter')) {
                if (ssr) {
                    reposnse.cookie('isSignedUpForNewsletter', `true`);
                } else {
                    writeSessionCookie('isSignedUpForNewsletter', 'true');
                }
            }
        }
    }
};

export const initNewsletterPopUp = (store) => {
    new NewsletterPopUp(store);
};

export class NewsletterPopUp {
    store: any;
    timeoutId: number;
    resetTimerInterval: number = 0;

    constructor(store) {
        this.store = store;
        this.newsletterPopUp(5000);
    }

    showPopUpOnExitIntent = (evt) => {
        if (evt.relatedTarget === null) {
            document.removeEventListener('mouseout', this.showPopUpOnExitIntent, false);
            // An intent to exit has happened
            this.newsletterPopUp(1);
        }
    };
    newsletterPopupVersions = () => {
        return {
            showVersionA: () => {
                this.newsletterPopUp(90000);
            },
            showVersionB: () => {
                // Do nothing.
            },
            showVersionC: () => {
                this.showPopUpTimerIdleTimeout(20000);
            },
            showVersionD: () => {
                document.addEventListener('mouseout', this.showPopUpOnExitIntent, false);
            },
        };
    };
    newsLetterModal = (args) => {
        this.timeoutId && window.clearTimeout(this.timeoutId);
        const abVersions = this.newsletterPopupVersions();
        if (abVersions[args]) abVersions[args]();
    };

    resetTimer = () => {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = window.setTimeout(this.idle, this.resetTimerInterval);
    };

    idle = () => {
        window.clearTimeout(this.timeoutId);
        window.removeEventListener('mousemove', this.resetTimer);
        window.removeEventListener('mousedown', this.resetTimer);
        window.removeEventListener('keypress', this.resetTimer);
        window.removeEventListener('scroll', this.resetTimer);
        this.newsletterPopUp(1);
    };

    newsletterPopUp = (timeout) => {
        window.clearTimeout(this.timeoutId);
        const { pageData } = this.store.getState();
        const { pageType } = pageData;
        let shouldNewsletterModalShown = this.shouldNewsletterModalShown();
        const newState = {
            popUp: {
                shouldNewsletterModalShown,
                timeout,
            },
        };
        this.timeoutId = window.setInterval(() => {
            if (!shouldNewsletterModalShown) this.cancelNewsletterModal();
            if (hasConsentUpdated()) {
                this.cancelNewsletterModal();
                window.setTimeout(() => {
                    eventTracker.track({
                        event: 'event',
                        category: 'newsletter-PI',
                        action: 'click',
                        label: pageType,
                    });

                    updateNewsletterPopUpData(newState)(this.store.dispatch);
                }, 10000);
            }
        }, timeout);
    };

    cancelNewsletterModal = () => {
        window.clearInterval(this.timeoutId);
    };

    shouldNewsletterModalShown = () => {
        const { pageData, router, newsletterPage } = this.store.getState();
        const { brandConfig, appConfig } = pageData;
        const { pageType } = router;
        const excludeNewsletterModalList = [
            newsletterLandingPage,
            requestFormPage,
            thankYouPage,
            welcomePage,
            searchResultPage,
        ];
        const newsletterModalFeatureFlag = pageData?.featureFlags?.find(
            (e) => e.feature === 'newsletterModal',
        );
        const isNewsletterModalEnabledByFeatureFlag = newsletterModalFeatureFlag
            ? newsletterModalFeatureFlag?.isEnabled
            : false;
        const shouldNewsletterModalShown =
            !isNewsletterModalCookie() &&
            excludeNewsletterModalList.indexOf(pageType) === -1 &&
            isNewsletterModalEnabledByFeatureFlag;
        const routeSlugs = getRouteSlugs(brandConfig.slugs);
        const newsletterPageSlug = routeSlugs.NewsletterPage;
        if (shouldNewsletterModalShown && !newsletterPage.title) {
            loadNewsletterPageData(this.store.dispatch, appConfig.apiHost, newsletterPageSlug);
        }

        return shouldNewsletterModalShown;
    };

    showPopUpTimerIdleTimeout = (timeout) => {
        this.resetTimerInterval = timeout; //set the idle timeinterval in class instance variable.
        this.timeoutId = window.setTimeout(this.idle, this.resetTimerInterval);
        let shouldNewsletterModalShown = this.shouldNewsletterModalShown();
        if (shouldNewsletterModalShown) {
            window.addEventListener('scroll', this.resetTimer);
            window.addEventListener('mousemove', this.resetTimer);
            window.addEventListener('mousedown', this.resetTimer);
            window.addEventListener('keypress', this.resetTimer);
        }
    };

    isHashRoute = (href: string): boolean => {
        return !!href.match(/^#/);
    };

    openUrl = (primaryUrl) => {
        setTimeout(() => (window.location.href = primaryUrl), 0); // The setTimeout is neccessary...
    };

    checkNewsletterQuerystringParams = () => {
        const queryString = url.parse(location.href).query;
        const { utm_source, utm_medium } = qs.parse(queryString);
        if (utm_source && utm_medium) {
            if (utm_source.includes('newsletter_') || utm_medium === 'email') {
                if (!readCookie('isSignedUpForNewsletter')) {
                    writeSessionCookie('isSignedUpForNewsletter', 'true');
                }
            }
        }
    };
}
